import styled from 'styled-components';
import { ReactComponent as LabelIcon } from './label.svg';

const LabelIconStyled = styled(LabelIcon)`
    margin-right: 8px;
`;

export default LabelIconStyled;
